import { Component, OnInit, Input } from '@angular/core';
import { AssociateService } from '../shared/services/associate.service';
declare var $: any;


@Component({
  selector: 'app-management-chart',
  templateUrl: './management-chart.component.html',
  styleUrls: ['./management-chart.component.css']
})
export class ManagementChartComponent implements OnInit {
  @Input() query;
  public dataLM;
  public dataFM;
  public isNoAssociates: Boolean = true;
  oc :any;

  constructor(public associateService: AssociateService) { }

  ngOnInit() {
    this.associateService.getManagementHeirarchyGraphical(this.query).subscribe(data => {
      if (Object.keys(data).length ) {
        this.dataLM = data['managerHeirarchy']['Opcos'];
        this.isNoAssociates = false;
        $('#orga_chart_main').on('mouseenter mouseleave',function() {
          $('.popover').removeClass('show');
        });
        $('.popover').on('mouseleave',function() {
          $('.popover').removeClass('show');
        });
        $('#chartContainerId,#chartContainerId2').on('mouseleave', '.isNode', function(event) {
          var node= $(this);
          $('.popover').removeClass('show');
        });
        $('#chartContainerId,#chartContainerId2').on('mouseenter', '.isNode', function(event)  {
          event.stopPropagation();
          var node= $(this);
          let asscAvatar = node.attr('assc-avatar'),
            asscName = node.attr('assc-name'),
            asscgroupId = node.attr('assc-groupId'),
            asscJobTitle = node.attr('assc-jobTitle'),
            asscCompany = node.attr('assc-company'),
            asscGender = node.attr('assc-gender'),
            asscId = node.attr('assc-id');
            if (asscName !== 'These Associates belongs to Parent Company') {
              node.popover({
                trigger: 'manual',
                container: 'body',
                template: `<div class="popover" role="tooltip">
                    <div class="arrow"></div>
                    <div class="org-popover">
                      <div class="row container-fluid">
                        <div class="col-sm-4">
                          <img src='https://s3-ap-southeast-1.amazonaws.com/epeoples3-production/`+ asscAvatar +`' class="xs-mt-15" width="42"/>
                        </div>
                        <div class="col-sm-8">
                          <h4> <a href='home/associate/profile/view/${asscId}'>` +asscName+`</a></h4>
                          <p>`+asscgroupId+`</p>
                        </div>
                      </div>
                      <div class="row container-fluid">
                        <div class="col-sm-4">
                          <p><b>Job Title</b></p>
                        </div>
                        <div class="col-sm-8">
                          <p>`+asscJobTitle+`</p>
                        </div>
                      </div>
                      <div class="row container-fluid">
                        <div class="col-sm-4">
                          <p><b>Company</b></p>
                        </div>
                        <div class="col-sm-8">
                          <p>`+asscCompany+`</p>
                        </div>
                      </div>
                      <div class="row container-fluid">
                        <div class="col-sm-4">
                          <p><b>Gender</b></p>
                        </div>
                        <div class="col-sm-8">
                          <p>`+asscGender+`</p>
                        </div>
                      </div>
                    </div>
                  </div>`
              })
              node.popover('show');
            }
        });

        this.instantiateChart(this.dataLM,data['id']);
        
        // --------------------------------------------------------- Functional Manager chart
        // this.instantiateChart(this.dataFM,data['id']);

      } else {
        this.isNoAssociates = true;
      }
    }, err => {
      console.log(err);
    })
  }
  instantiateChart(dataSource,dataId){
    this.oc = $('#chartContainerId').orgchart({
      data: dataSource,
      nodeTitle: 'title',
      nodeContent: 'description',
      draggable: false,
      pan: false,
      zoom: true,
      zoomoutLimit: 0.3,
      zoominLimit: 2,
      visibleLevel: 3,
      nodeId: dataId,
      exportButton: false,
      nodeTemplate: function(data) {
        return `<div class="borderBox isNode" assc-id="`+data.assoc.id+`" assc-name="`+data.assoc.name+`" assc-avatar="`+data.assoc.avatarUrl+`"
        assc-jobTitle="`+data.assoc.jobDescription+`" assc-company="`+data.assoc.company+`"
        assc-gender="`+data.assoc.gender+`" assc-groupId="`+data.assoc.groupId+`"
        data-toggle="popover" data-content="Org popover" data-animation="false">
                  <div class="row">
                    <div class="col-lg-4">
                      <div class="imgDimCompanyTile">
                        <img src='https://s3-ap-southeast-1.amazonaws.com/epeoples3-production/`+data.assoc.avatarUrl+`' class="img-responsive maxHeightImg"/>
                      </div>
                    </div>
                    <div class="col-lg-8 text-left xs-pl-5">
                      <div class="toLeft nameCompanyTile">
                        <div class="d_gray mb-4" style="text-align: center; text-align-last: center; font-size: 9px;">
                        <a href='home/associate/profile/view/${data.assoc.id}'>`+data.assoc.name+`
                        </a>
                        </div>
                      </div>
                      <div class="toLeft">
                        <div class="l_gray">`+data.assoc.groupId+`</div>
                      </div>
                    </div>
                  </div>
                </div>`;
      },
      initCompleted :function() {
        let tx= $(".orgchart").outerWidth() / 2 * -1,
        offset = $(".chartContainerId").outerWidth(),
        totalOffset = tx + offset ;
        $(".orgchart").css( {"transform": `matrix(0.8, 0, 0, 0.8, `+ totalOffset+`, -13)`});
      }

    })
  }

}
